import { FontTheme } from '../types';

export default {
  web: {
    bold: {
      fontFamily: 'IRANSansX-Black , Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '700',
    },
    regular: {
      fontFamily: 'IRANSansX-Regular, Roboto, Helvetica, Arial, sans-serif',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'IRANSansX-Regular, Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '500',
    },
    light: {
      fontFamily: 'IRANSansX-light, Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '300',
    },
    thin: {
      fontFamily: 'IRANSansX-thin, Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '100',
    },
  },
  default: {
    bold: {
      fontFamily: 'IRANSansX-Black',
      fontWeight: '700',
    },
    regular: {
      fontFamily: 'IRANSansX-Regular',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'IRANSansX-medium',
      fontWeight: '500',
    },
    light: {
      fontFamily: 'IRANSansX-light',
      fontWeight: '300',
    },
    thin: {
      fontFamily: 'IRANSansX-thin',
      fontWeight: '100',
    },
  },
  ios: {
    bold: {
      fontFamily: 'IRANSansX-Black',
      fontWeight: '700',
    },
    regular: {
      fontFamily: 'IRANSansX-Regular',
      fontWeight: '400',
    },
    medium: {
      fontFamily: 'IRANSansX-medium',
      fontWeight: '500',
    },
    light: {
      fontFamily: 'IRANSansX-light',
      fontWeight: '300',
    },
    thin: {
      fontFamily: 'IRANSansX-thin',
      fontWeight: '100',
    },
  },
} as FontTheme;
